export default __webpack_public_path__ + "static/media/fab-logo.b2d43197.png";